import { RESET_EDIT_CAT } from '../types'
export const reseteditcat = () => {

    return (dispatch) => {
        dispatch({ type: RESET_EDIT_CAT });
    }
}